

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { employeeApis, Employee } from '@/api';

@Component
export default class EmployeeEmailSelect extends Vue {
  @Prop({ type: Boolean, default: true }) multiple!: boolean;
  @Prop({ default: undefined }) value!: string | string[];
  @Prop({ default: '' }) placeholder!: string;

  employeeLoading = false;
  employeeOptions: Employee[] = [];

  private selectedEmailSet(value: string | string[]): Set<string> {
    return this.multiple ? new Set(value as string[]) : new Set([value as string]);
  }

  private selectedEmailList(value: string | string[]): string[] {
    return this.multiple ? (value as string[]) : value ? [value as string] : [];
  }

  // eml 导入等直接赋值的邮箱没经过搜索, 按邮箱查员工补进选项列表, 让选择器显示「名字 <邮箱>」
  @Watch('value', { deep: true, immediate: true })
  ensureSelectedOptions() {
    const emails = this.selectedEmailList(this.value);
    const missing = emails.filter(
      email => email && !this.employeeOptions.some(e => e.email.toLowerCase() === email.toLowerCase())
    );
    missing.forEach(email => {
      employeeApis
        .search({ name: email, internal: true })
        .then(list => {
          const hit = list.find(e => e.email.toLowerCase() === email.toLowerCase());
          if (hit) {
            this.employeeOptions.push(hit);
            this.$emit('selected-employees', [hit]);
          }
        })
        .catch(error => {
          // 查不到姓名不影响使用, 保持原样显示
          console.error(`查询员工 ${email} 失败:`, error);
        });
    });
  }

  onInput(value: string | string[]) {
    this.$emit('input', value);
  }

  // change 先于 input 触发, 用事件参数里的新值
  onChange(value: string | string[]) {
    const selected = this.selectedEmailSet(value);
    const employees = this.employeeOptions.filter(e => selected.has(e.email));
    this.$emit('selected-employees', employees);
  }

  searchEmployees(name: string) {
    this.employeeLoading = true;
    employeeApis
      .search({ name, internal: true })
      .then(list => {
        // 保留已选员工, 避免选中后从选项列表消失
        const selectedEmails = this.selectedEmailSet(this.value);
        const selected = this.employeeOptions.filter(e => selectedEmails.has(e.email));
        const merged = [...list, ...selected];
        this.employeeOptions = merged.filter((e, i) => merged.findIndex(x => x.email === e.email) === i);
      })
      .finally(() => {
        this.employeeLoading = false;
      });
  }
}
